import { render, staticRenderFns } from "./SimulationDetail.vue?vue&type=template&id=b2fd6914&"
import script from "./SimulationDetail.vue?vue&type=script&lang=js&"
export * from "./SimulationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports